import axios from 'axios'

const cmsApiInstance = axios.create({
  baseURL: import.meta.env.VITE_CMS_API_URL
})

export default cmsApiInstance
